
import React from 'react';

interface DaySelectorProps {
    activeDays: { day: string; available: boolean }[];
    selectedDay: string | null;
    onSelectDay: (day: string | null) => void;
}

const DaySelector: React.FC<DaySelectorProps> = ({ activeDays, selectedDay, onSelectDay }) => {
    return (
        <div className="mb-6">
            <h2 className="text-2xl font-bold mb-2">Available Days</h2>
            <div className="flex gap-3 flex-wrap">
                {activeDays.map((d) => (
                    <button
                        key={d.day}
                        onClick={() => onSelectDay(d.day)}
                        className={`px-4 py-2 rounded-lg font-medium border transition-colors
              ${selectedDay === d.day
                                ? "bg-indigo-600 text-white border-indigo-600"
                                : "bg-white text-indigo-700 border-indigo-400 hover:bg-indigo-50"
                            }`}
                    >
                        {d.day}
                    </button>
                ))}

                {selectedDay && (
                    <button
                        onClick={() => onSelectDay(null)}
                        className="px-3 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition-colors"
                    >
                        Clear
                    </button>
                )}
            </div>
        </div>
    );
};

export default DaySelector;
